export default "/public/dist/img/img_n1.jpg";